<template>
  <div class="">
    <van-nav-bar
      title="套餐活动"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
   <van-swipe :autoplay="2000">
        <van-swipe-item >
          <img
            class="imgss"
            src="../../../assets/tao/01.jpg"
          />
          <!-- <img v-lazy="image.adv_img" /> -->
        </van-swipe-item>
         <van-swipe-item>
           <img
            class="imgss"
            src="../../../assets/tao/011.jpg"
          />
        </van-swipe-item>
        <van-swipe-item>
           <img
            class="imgss"
            src="../../../assets/tao/012.jpg"
          />
        </van-swipe-item>
      </van-swipe>
    
       <div class="goods">
        <div class="jing">
          <!-- 超值精选 爆款推荐 -->
        </div>
           <!-- <div class="activity">
        <div
          class="tu"
          @click="go"
        >
          <img
            src="../../assets/a1.jpg"
            alt=""
          />
        </div>
        <div class="wen">
          <div class="left">
            <p>各大活动，敬请期待</p>
            <p></p>
          </div>
          <div class="right">
            <van-count-down :time="time">
              <template v-slot="timeData">
                还剩
                <span class="item">{{ timeData.hours }}</span>: <span class="item">{{ timeData.minutes }}</span>:
                <span class="item">{{ timeData.seconds }}</span>
              </template>
            </van-count-down>
          </div>
        </div>
      </div> -->
      <div class="content">
        
        <div class="nav">
         
          <ul class="clearfix">
             <div class="navs">
            搭配购分类
          </div>
            
            <li @click="gol(1720,'生态板活动套餐')">
              <img src="../../../assets/tao/06.png" alt="">
            </li>
            <li @click="gol(1722,'玖伍贰柒阻燃板活动套餐')">
              <img src="../../../assets/tao/14.png" alt="">
            </li>
           
            <li @click="gol(1723,'小巨人欧松板活动套餐')">
              <img src="../../../assets/tao/15.png" alt="">
            </li>
            <li @click="gol(1724,'杨木细木工板活动套餐')">
              <img src="../../../assets/tao/07.png" alt="">
            </li>
          </ul>
        </div>
        <div class="foot">
          <div class="ft">
            钜惠搭配 更多选择
          </div>
          <div class="fi">
            <img src="../../../assets/tao/11.png" alt="">
          </div>
          <div class="fi" >
            <img src="../../../assets/tao/12.png" alt="">
          </div>
          <div class="fi" >
            <img src="../../../assets/tao/13.png" alt="">
          </div>
        </div>
      </div>
       </div>
       

  </div>
</template>
<script>
import Vue from 'vue'

import { NavBar, AddressList, Toast,Swipe, SwipeItem, Lazyload,CountDown,Progress } from 'vant'

Vue.use(NavBar).use(AddressList).use(Toast).use(Swipe)
  .use(SwipeItem)
  .use(Lazyload, { lazyComponent: true }).use(CountDown).use(Progress);
export default {
  created () {
    //  this.axios.get('listGoodsByCateBrand', { params: { store_id: this.$store.state.shopid, class_id: 1634, class_name:'包装板'} }).then(res => {
    //       console.log(res)
    //       this.list=res.data.data
    //     }).catch(ref => { })
    //    if (JSON.parse(localStorage.getItem('user')).id != 0) {
    //   this.login = 1
    // } else {
    // }
    // if ([16, 17, 23].indexOf(this.$store.state.shopid) == -1) {
    //   this.jf = true
    // } else {
    //   this.jf = false
    // }
    
   
  },
  mounted(){
    console.log(this.$store.state.scroll)

   
  },
  data () {
    return {
      chosenAddressId: '1',
       time: 3000,
     list:[],
     specs_show:false,
    sid:'',
    pname:'',
    oid:[],
    ptimg:[],
    };
  },
  methods: {
   
   
    onClickLeft () {
      this.$router.go(-1)
    },
   go(id){
    
    
   },
   gol(id,cname){
    
    this.$router.push({name:'taohh',query:{id,cname}})
    
   },
   goa(id){
    
   },
   gos(){
    console.log(666)
     

   }
    
    
  },
  components: {
 
    // One
  },
}
</script>
<style lang="less" scoped>
.activity {
    height: 6.266667rem;
    overflow: hidden;
    border-radius: 0.4rem;
      background-color: #fff600;

    .tu {
      width: 100%;
      height: 4.293333rem;
    }
    .wen {
      background-color: #fff600;
      height: 2rem;
      display: flex;
      .left {
        padding-top: 0.5rem;
        padding-left: 0.2rem;
        flex: 0.6;
        p:nth-child(1) {
          font-weight: 700;
          height: 0.64rem;
        }
        p:nth-child(2) {
          color: #f00;
        }
      }
      .right {
        color: #575c66;
        padding-top: 0.6rem;
        flex: 0.4;
      }
    }
  }
  .js{
    padding-top: 0.5rem;
    text-align: center;
    font-size: 0.45rem;
    color: rgb(59, 44, 44);
  }
  .goods{
      background-color: #fee006;

  }
  .jing{
    color: #ed1313;
    font-size: 0.5rem;
    font-weight: 600;
    text-align: center;
    // height: 3rem;
    line-height: 1rem;
      background-color: #fee006;
      // position: relative;

      // z-index: 9;

  }
  .content {
      background-color: #542919;
      // position: relative;
      // top: -2rem;
    // padding: 0.2rem;
   
    ul {
      li {
        // float: left;
        // width: 45%;
        // padding: 0.266667rem 0.01rem 0.1rem 0.533333rem;
        // padding-left: 0.1rem;
        // padding-right: 0.1rem;
        // margin-left: 0.1rem;
        position: relative;
        margin: 0.4rem 0 0rem 0rem;
        .se{
          background-color: #fee006;
          height: 3rem;
          width: 100%;
          position: absolute;
          top: 0;
          z-index: 1;
        }
       
        .tao{
          position: relative;
          z-index: 2;
          padding: 0 0.2rem;
        }
        .con{
        background-color: rgb(238, 236, 236);

        }
        
        .price {
          height: 0.9rem;
          line-height: 0.9rem;
          font-size: 0.4rem;
          color: #a22d2b;
        }
        .name {
          font-size: 0.373333rem;
            padding-top: 0.2rem;

          color: #333;


        }
        .progress{
            // overflow: hidden;
            padding-top: 0.2rem;
           margin-left: 3rem;
            width: 65%;
        }
        .num{
            // float: right;
            // height: 2rem;
            text-align: right;
            padding-right: 0.2rem;
            // line-height: -2rem;
        }
        .name2 {
          font-size: 0.373333rem;
          color: #333;
         padding: 0.1rem;
         padding-top: 0.2rem;
        }
         .name3 {
          font-size: 0.373333rem;
          color: rgb(241, 49, 49);
         padding: 0.1rem;
        //  padding-top: 0.2rem;
        }
      }
    }
     .an{
    margin-top: 0;
  }
  }
 .nav{
  padding: 0.2rem;
  padding-top: 0.4rem;
  .navs{
    color: #542919;
    font-size: 0.55rem;
    text-align: center;
    line-height: 1rem;
    font-weight: 600;
  }
  ul{
  padding: 0.2rem;
  border-radius: 0.5rem;

  background-color: #fff;

    li{
      float: left;
      width: 50%;
    }
  }
 }
 .foot{
  .ft{
    color: #fee006;
    font-size: 0.55rem;
    text-align: center;
    line-height: 1rem;
    font-weight: 600;
  }
  .fi{
    padding: 0.2rem;
    border-radius: 0.5rem;
  }
 }
</style>